if (!process.env.VUE_APP_API_URL) {
    alert('Missing API url');
}

const BACKEND_URL = `//${process.env.VUE_APP_API_URL}`;

// Openstreetmap

const MAP_PROVIDER = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

const MAP_ATTRIBUTION = '© OpenStreetMap contributors © CARTO';





// 🗺️ Carte Détaillée (mode français)
const MAP_PROVIDER_DETAILED = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const MAP_ATTRIBUTION_DETAILED = '© OpenStreetMap contributors';




// Openstreetmap France
//const MAP_PROVIDER = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
//const MAP_ATTRIBUTION = `© <a href="https://openstreetmap.fr">OpenStreetMap France</a> maps | © <a href="http://openstreetmap.org/copyright">OpenStreetMap</a> contributors`;

// Wikimedia
//const MAP_PROVIDER = 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png';
//const MAP_ATTRIBUTION = `© <a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a> | © <a href="http://openstreetmap.org/copyright">OpenStreetMap</a>`;

const MAPBOX_TOKEN = 'pk.eyJ1IjoibW9saW5hcGx1Z2ltbW8iLCJhIjoiY2tuaGZjZmh6MmtqMjJ4bXVkNTcxeGE3byJ9.Y2-v2jcSNrcqGkT_eWuZLw';

export { BACKEND_URL, MAP_PROVIDER, MAP_ATTRIBUTION,  MAP_PROVIDER_DETAILED, 
    MAP_ATTRIBUTION_DETAILED, MAPBOX_TOKEN };
